import type { ApiQuery } from '../../api';

import { apiName } from './constants';

export const getCacheKey = (query: ApiQuery): string => apiName.concat(JSON.stringify(query));
